import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const navLinks = [{
    name: 'Comment ça marche',
    href: '#how-it-works'
  }, {
    name: 'Avantages',
    href: '#features'
  }, {
    name: 'Sécurité',
    href: '#trust'
  }];
  const whatsappUrl = 'https://wa.me/2250700592164';
  return <nav className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-109">
      <div className="container mx-auto px-4 md:px-6" data-id="element-110">
        <div className="flex h-16 items-center justify-between" data-id="element-111">
          {/* Logo */}
          <div className="flex items-center" data-id="element-112">
            <a href="/" className="text-2xl font-bold text-primary" data-id="element-113">
              CafaPay
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-8" data-id="element-114">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary" data-id="element-115">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" onClick={() => window.open(whatsappUrl, '_blank')} data-id="element-116">
              Commencer
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex md:hidden" data-id="element-117">
            <button type="button" className="text-muted-foreground hover:text-primary" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-118">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-119" /> : <Menu className="h-6 w-6" data-id="element-120" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden border-b bg-background" data-id="element-121">
          <div className="container mx-auto px-4 py-4 space-y-4" data-id="element-122">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block text-sm font-medium text-muted-foreground hover:text-primary" onClick={() => setIsMenuOpen(false)} data-id="element-123">
                {link.name}
              </a>)}
            <div className="pt-2" data-id="element-124">
              <Button variant="primary" className="w-full" onClick={() => window.open(whatsappUrl, '_blank')} data-id="element-125">
                Commencer
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}